/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import NavLinkbar from "./components/NavLinkBar";

import * as St from "./styles";

function App() {
  const [platform, setPlatform] = useState<string | null>(null);

  /**
   * @description Funcao para validar se o app esta instalado via deep link, caso o app nao esteja instalado, redireciona para o site.
   * Caso o app esteja instalado, o app sera aberto.
   */
  const validateAppInstallation = (deeplink: string, storeLink: string) => {
    // window.location = deeplink;
    // use href assignment to navigate to a string URL
    window.location.href = deeplink;
    let fallbackLink = storeLink;
    // setTimeout ainda executa depois que o aplicativo é aberto, então a página atual navegará para o link de fallback
    // para evitar isso, eu uso a função document.hasFocus para verificar
    setTimeout(function () {
      // se o aplicativo for aberto, o documento não estará focado
      // então se o aplicativo não estiver instalado, o documento estará focado
      if (document.hasFocus()) {
        window.open(fallbackLink, "_blank");
      }
    }, 1000);
  };

  /**
   * @description Função que verifica o sistema operacional e redireciona para a loja correspondente
   * Caso o sistema não seja Android ou iOS, exibe uma mensagem na tela para o usuário
   */
  const redirectToStore = async () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    console.log(userAgent);

    // Verifica se é iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setPlatform("iPhone");
      validateAppInstallation(
        "novaeracard://proposalInfo",
        "https://apps.apple.com/br/app/teucard-do-teu-jeito/id1562686964"
      );
    } else if (/android/i.test(userAgent)) {
      setPlatform("Android");
      validateAppInstallation(
        "novaeracard://novaeracard/proposalInfo",
        "https://play.google.com/store/apps/details?id=com.novaera"
      );
    } else {
      setPlatform("Windows");
    }
  };

  const sendToStore = () => {
    if (platform === "Android") {
      window.open(
        "https://play.google.com/store/apps/details?id=com.novaera",
        "_blank"
      );
    } else if (platform === "iPhone") {
      window.open(
        "https://apps.apple.com/br/app/teucard-do-teu-jeito/id1562686964",
        "_blank"
      );
    } else if (platform === "Windows") {
      window.open(
        "https://play.google.com/store/apps/details?id=com.novaera",
        "_blank"
      );
    }
  };

  useEffect(() => {
    redirectToStore();
  }, []);

  return (
    <St.Container>
      <NavLinkbar />
      <St.InfoSec>
        <St.ContainerInfo>
          <St.InfoRow>
            <St.InfoColumn>
              <St.TextWrapper>
                <St.TopLine>TEUCARD</St.TopLine>
                <St.Heading>Crie agora a Tua carteira digital</St.Heading>
                <St.Subtitle>
                  Com o app do TeuCard você pode utilizar cartões de outros
                  bancos pela Tua Carteira digital e realizar compras utilizando
                  o QR Code.
                </St.Subtitle>
                <St.Button onClick={() => sendToStore()}>
                  Instale o app e aproveite as vantagens
                </St.Button>
              </St.TextWrapper>
            </St.InfoColumn>
            <St.InfoColumn>
              <St.ImgWrapper>
                {/* <St.Img src={img} /> */}
              </St.ImgWrapper>
            </St.InfoColumn>
          </St.InfoRow>
        </St.ContainerInfo>
      </St.InfoSec>
    </St.Container>
  );
}

export default App;
